import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import {
  Search as SearchIcon,
  GridOn as ExcelIcon,
  ArrowBackIosNew,
  FormatListNumberedOutlined,
} from "@mui/icons-material";
import MainLayout from "../../admin/MainLayout";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import * as XLSX from "xlsx";
import { useDispatch, useSelector } from "react-redux";
import { fetchGroheProject } from "../../../redux/slices/dashSlice";
import LoadingIndicator from "../../utils/LoadingIndicator";
const FY_MONTH_ORDER = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

const OpenGroheBrandQuote = forwardRef(
  ({ search, role, user, from, to, month, year, selectedRegion, selectedState, selectedChannels}, ref) => {
    const dispatch = useDispatch();
    const { groheProject, totalCount, getStatus } = useSelector(
      (state) => state.dash
    );

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    useEffect(() => {
      dispatch(
        fetchGroheProject({
          page: page + 1,
          rowsPerPage,
          search: search,
          role: role,
          user:  user,
          from: from,
          to: to,
          month: from || to ? null :month,
          year: from || to ? null :year,
          selectedRegion,
          selectedState,
          selectedChannels:selectedChannels
        })
      );
    }, [dispatch, page, rowsPerPage, search, role,from,to, user, month, year, selectedRegion, selectedState, selectedChannels]);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    useImperativeHandle(ref, () => ({
      downloadExcel: () => {
        if (!groheProject || groheProject.length === 0) return;

        const dataToExport = groheProject?.map((client, index) => ({
          "S.No.": index + 1,
          "Usage Count": client.count,
          "Quotation ID": client.project_id,
          Client: client.client_name,
          Username: client.username,
          Role:
            client.role == 2
              ? "IC"
              : client.role == 3
              ? "BSP"
              : client.role == 4
              ? "DSP"
              : client.role == 5
              ? "BD"
              : client.role == 6
              ? "Sales Enabler"
              : client.role == 7
              ? "Dealer"
              : client.role == 8
              ? "Studio"
              : client.role,
          "Valid Upto": new Date(client.valid_date).toLocaleDateString("en-GB"),
          Stage: client.status,
          "Created At": new Date(client.created_at).toLocaleString("en-GB"),
          "Updated At": new Date(client.updated_at).toLocaleString("en-GB"),
        }));

        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Clients");
        XLSX.writeFile(wb, "grohe_brand_usage.xlsx");
      },
    }));

    return (
      <>
        <LoadingIndicator show={getStatus === "pending"} />

        <Box sx={{ width: "100%" }}>
          <Paper sx={{ width: "100%", borderRadius: 2, overflow: "hidden" }}>
            <TableContainer>
              <Table sx={{ minWidth: 750 }} aria-label="client table">
                <TableHead sx={{ background: "#04121f", color: "white" }}>
                  <TableRow>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      SL No.
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Usage Count
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Quotation ID
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Client
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Username
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Role
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Valid Upto
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Stage
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Created At
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Updated At
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groheProject?.length > 0 ? (
                    groheProject.map((client, index) => (
                      <TableRow
                        key={`${client.client_name}-${index}-${client.project_id}-${client.count}`}
                        hover
                        sx={{
                          "&:nth-of-type(odd)": { backgroundColor: "#f9fafb" },
                          "&:hover": { backgroundColor: "#eef2ff" },
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        <TableCell sx={{}}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell sx={{}}>{client.count}</TableCell>
                        <TableCell sx={{}}>{client.project_id}</TableCell>
                        <TableCell sx={{}}>{client.client_name}</TableCell>
                        <TableCell sx={{}}>{client.username}</TableCell>
                        <TableCell sx={{}}>
                          {client.role == 2
                            ? "IC"
                            : client.role == 3
                            ? "BSP"
                            : client.role == 4
                            ? "DSP"
                            : client.role == 5
                            ? "BD"
                            : client.role == 6
                            ? "Sales Enabler"
                            : client.role == 7
                            ? "Dealer"
                            : client.role == 8
                            ? "Studio"
                            : client.role}
                        </TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.valid_date).toLocaleDateString(
                            "en-GB"
                          )}
                        </TableCell>
                        <TableCell sx={{}}>{client.status}</TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.created_at).toLocaleString("en-GB")}
                        </TableCell>
                        <TableCell sx={{}}>
                          {new Date(client.updated_at).toLocaleString("en-GB")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography
                          variant="subtitle1"
                          color="text.secondary"
                          sx={{ py: 2 }}
                        >
                          No data available
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, totalCount || 0]}
              component="div"
              count={totalCount || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>
      </>
    );
  }
);

export default OpenGroheBrandQuote;
